import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import React, { useRef, useState } from 'react'
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons/faCircleQuestion'
import { fa1, fa2, fa3, fa4 } from '@fortawesome/free-solid-svg-icons'

export const StateIdPopover = () => {
    const [show, setShow] = useState(false)
    const hoverTimeoutRef = useRef<NodeJS.Timeout | undefined>(undefined)

    const handleOnPopoverMouseEnter = () => {
        clearTimeout(hoverTimeoutRef.current)
        setShow(true)
    }

    const handleOnMouseEnter = () => {
        clearTimeout(hoverTimeoutRef.current)
        setShow(true)
    }

    const handleOnMouseLeave = () => {
        hoverTimeoutRef.current = setTimeout(() => {
            setShow(false)
        }, 100)
    }

    const popover = (
        <Popover
            onMouseEnter={handleOnPopoverMouseEnter}
            onMouseLeave={handleOnMouseLeave}
            id="state-id-popover"
            style={{ width: '320px', maxWidth: '320px' }}
        >
            <Popover.Body className="d-flex flex-column gap-2 m-2">
                <span
                    className="app-color-default"
                    style={{ fontWeight: '600' }}
                >
                    You can use State IDs to trace when and how a config was
                    changed
                </span>
                <span className="d-flex gap-3 align-items-start">
                    <FontAwesomeIcon
                        icon={fa1}
                        className="pt-1"
                    />
                    <span>
                        Copy the State IDs of the entries you are interested in
                    </span>
                </span>
                <span className="d-flex gap-3 align-items-start">
                    <FontAwesomeIcon
                        icon={fa2}
                        className="pt-1"
                    />{' '}
                    <span>Download the logs for the required date</span>{' '}
                </span>
                <span className="d-flex gap-3 align-items-start">
                    <FontAwesomeIcon
                        icon={fa3}
                        className="pt-1"
                    />{' '}
                    <span>
                        Select the file and using Ctrl + F search the entry with
                        state ID
                    </span>
                </span>
                <span className="d-flex gap-3 align-items-start">
                    <FontAwesomeIcon
                        icon={fa4}
                        className="pt-1"
                    />
                    <span>
                        Compare the two config states and determine exactly what
                        was changed.
                    </span>
                </span>
            </Popover.Body>
        </Popover>
    )

    return (
        <OverlayTrigger
            overlay={popover}
            show={show}
            placement="left"
        >
            <div>
                <span>STATE ID</span> &nbsp;&nbsp;
                <span
                    onMouseEnter={handleOnMouseEnter}
                    onMouseLeave={handleOnMouseLeave}
                >
                    <FontAwesomeIcon
                        icon={faCircleQuestion}
                        size="sm"
                    />
                </span>
            </div>
        </OverlayTrigger>
    )
}
